import { render, staticRenderFns } from "./baseGridMD.vue?vue&type=template&id=380df3e0"
import script from "./baseGridMD.vue?vue&type=script&lang=js"
export * from "./baseGridMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports